import * as React from 'react';
import IDateRangePicker from './IDateRangePicker';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css'; // tslint:disable-line
import './restyle_react-datepicker.css'; // tslint:disable-line
import * as style from './DateRangePickerStyle.module.scss'

const DateRangePicker: React.SFC<IDateRangePicker> = (props) => {

  const handleChange = ({ startDate, endDate }: { startDate?: Date; endDate?: Date }) => {
    const setStartDate = startDate || props.startDate;
    let setEndDate = endDate || props.endDate;

    if (setStartDate && setEndDate && moment(setStartDate).isAfter(setEndDate)) {
      setEndDate = setStartDate;
    }

    props.updateState({
      startDate: setStartDate, endDate: setEndDate,
    });
  };

  const handleChangeStart = (startDate: Date) => {
    handleChange({ startDate });
  };

  const handleChangeEnd = (endDate: Date) => {
    handleChange({ endDate });
  };

  const hideKeyboard = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.blur();
  };

  return (
    <div className={style.datePickerFilter}>
      <div className={style.datePickerFilterSection}>
        <div>
          <p>From</p>
          <DatePicker
            selected={props.startDate || null}
            selectsStart={!props.notSelected}
            onChange={handleChangeStart}
            dateFormat="d MMM yyyy"
            placeholderText={props.notSelected ? 'Select...' : moment(props.startDate).format('D\xa0MMM\xa0YYYY')}
            minDate={props.minDate}
            maxDate={props.maxDate}
            showMonthDropdown={true}
            showYearDropdown={true}
            dropdownMode="select"
            startDate={props.startDate}
            endDate={props.endDate}
            withPortal={true}
            onFocus={hideKeyboard}
          />
        </div>
      </div>
      <div className={style.datePickerFilterSection}>
        <div>
          <p>To</p>
          <DatePicker
            selected={props.endDate || null}
            startDate={props.startDate}
            endDate={props.endDate}
            selectsEnd={!props.notSelected}
            onChange={handleChangeEnd}
            dateFormat="d MMM yyyy"
            placeholderText={props.notSelected ? 'Select...' : moment(props.startDate).format('D\xa0MMM\xa0YYYY')}
            minDate={props.minDate}
            maxDate={props.maxDate}
            showMonthDropdown={true}
            showYearDropdown={true}
            dropdownMode="select"
            withPortal={true}
            onFocus={hideKeyboard}
          />
        </div>
      </div>
    </div>
  );
};

export default DateRangePicker;
